import { CashClockIcon } from './CashClockIcon';

/**
 * author: Michael Irigoyen
 * id D9D0A7DF-0450-4F67-9F50-D46733A1DF3B
 * name cash-clock
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-clock.svg
 * tags
 * - Banking 
 * - Currency 
 * - Date / Time 
 */
export const PaymentClockIcon = CashClockIcon;
export default PaymentClockIcon